import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type PeraturanData = {
  CLW_ISI_IDX: number;
  CLW_ISI_NOMOR: string;
  CLW_ISI_TAHUN: string;
  CLW_MENU_NAME: string;
  CLW_VIEW: number;
  CLW_ISI_KETERANGAN: string;
  CLW_BERLAKU: number;
};

type InitialState = {
  dataPeraturan: PeraturanData[];
  totalData: number;
};

const initialState: InitialState = {
  dataPeraturan: [
    
    // Add more data items as needed
  ],
  totalData: 0, // Initialize totalData here
};

export const peraturan = createSlice({
  name: 'peraturan',
  initialState,
  reducers: {
    replaceAllPeraturan: (state, action: PayloadAction<PeraturanData[]>) => {
      state.dataPeraturan = action.payload; // Replace the entire array with the new array
    },
    updateTotalData: (state, action: PayloadAction<number>) => {
      state.totalData = action.payload; // Update the totalData value in the state
    },
  },
});

export const { replaceAllPeraturan, updateTotalData } = peraturan.actions;
export default peraturan.reducer;
